import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, AfterViewInit } from '@angular/core';
import Player from '@vimeo/player';

@Component({
  selector: 'vimeo-player',
  templateUrl: './vimeo-player.component.html',
  standalone: true,
  styleUrls: ['./vimeo-player.component.css']
})
export class VimeoPlayerComponent implements OnChanges, AfterViewInit {
  @ViewChild('vimeoPreviewContainer') vimeoPreviewContainer!: ElementRef;
  @Input() vimeoVideoId: string = '';

  private player: Player | null = null;

  ngAfterViewInit() {
    if(this.vimeoVideoId && this.vimeoVideoId !== ''){
      const vimeoUrl = `https://player.vimeo.com/video/${this.vimeoVideoId}`;
      if (this.player) {
        this.player.loadVideo(vimeoUrl).then(() => {
          // console.log('Video loaded');
        }).catch((error: Error) => {
          console.error('Error loading video:', error);
        });
      } else {
        this.player = new Player(this.vimeoPreviewContainer.nativeElement, { url: vimeoUrl });
      }
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['vimeoVideoId'] && !changes['vimeoVideoId'].isFirstChange()) {
      const vimeoUrl = `https://player.vimeo.com/video/${this.vimeoVideoId}`;
      if (this.player) {
        this.player.loadVideo(vimeoUrl).then(() => {
          // console.log('Video loaded');
        }).catch((error: Error) => {
          console.error('Error loading video:', error);
        });
      } else {
        this.player = new Player(this.vimeoPreviewContainer.nativeElement, { url: vimeoUrl });
      }
    }
  }
}